/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { StudentGradeModuleViewModel } from "../types/StudentGradeModuleViewModel.ts";
import { studentGradeDisciplineViewModelSchema } from "./studentGradeDisciplineViewModelSchema.ts";

export const studentGradeModuleViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID do módulo.")),
  name: z.string().describe("Nome/descrição do módulo.").nullish(),
  disciplines: z
    .array(z.lazy(() => studentGradeDisciplineViewModelSchema))
    .describe(
      "Lista de disciplinas do módulo com ShowOnStudentDocument ativo, ordenadas pela data da primeira aula.",
    )
    .nullish(),
}) as unknown as ToZod<StudentGradeModuleViewModel>;
